import _ from '@lodash';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useState } from 'react';

import UserProfileEditService from '../service/UserProfileEditService';

function EmailChangeRequestField(props) {
    const methods = useFormContext();
    const { onChange } = props.field;
    const { compact = false } = props;

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const send = () => {
        const values = methods.getValues();
        const oldEmail = values?.oldEmail;
        const email = values?.email;
        const emailAgain = values?.emailAgain;

        if (!oldEmail) {
            dispatch(showMessage({ message: 'Current email is required.' }));
            return;
        }
        if (!email) {
            dispatch(showMessage({ message: 'New email is required.' }));
            return;
        }
        if (!EMAIL_RE.test(email)) {
            dispatch(showMessage({ message: 'Invalid email format.' }));
            return;
        }
        if (!emailAgain) {
            dispatch(showMessage({ message: 'Please confirm the new email.' }));
            return;
        }
        if (email !== emailAgain) {
            dispatch(showMessage({ message: 'Emails do not match.' }));
            return;
        }
        if (String(email).trim().toLowerCase() === String(oldEmail).trim().toLowerCase()) {
            dispatch(showMessage({ message: 'New email must be different from current.' }));
            return;
        }

        setLoading(true);

        UserProfileEditService.requestEmailChange(oldEmail, email).then((response) => {
            if (response?.successful) {
                dispatch(showMessage({ message: 'Successfully created' }));
                onChange && onChange(email);
            } else {
                dispatch(showMessage({ message: 'Successfully created' }));
            }
        }).catch((e) => {
            const err = e?.message || 'Unexpected error while sending email change request.';
            dispatch(showMessage({ message: err }));
        }).finally(() => {
            setLoading(false);
        });
    };

    return (
        <div className={clsx(compact ? 'flex items-center px-8' : 'flex items-center px-8 mt-8 mb-16', props.fieldConfig?.className)}>
            <Button variant="contained" color="primary" className="w-full" onClick={send} disabled={loading}>
                {loading ? 'Sending Request' : 'Request Email Change'}
            </Button>
        </div>
    );
}

export default EmailChangeRequestField;